import { TopBarSelectors } from "src/redux/TopBar/selectors";
import { ROLE } from "src/redux/TopBar/constants";

export const AuthSelectors = {
    IsLoggedIn: (state) => state.Auth.isLoggedIn,
    UserRole: (state) => state.Auth.userRole,
    IsTraderRole: (state) => state.Auth.userRole === "trader",
    GetAuthConfig: (state) => state.Auth.authConfig,
    GetAuthFiles: (state) => state.Auth.files,
    View: (state) => state.Auth.view,
    SignupError: (state) => state.Auth.signupError,
    LoginError: (state) => state.Auth.loginError,
    AppInitFailed: (state) => state.Auth.appInitFailed,
    User: (state) => state.Auth.user,
    Email: (state) => state.Auth.email,
    Password: (state) => state.Auth.password,
    SignupEmail: (state) => state.Auth.signupEmail,
    UsesClientPool: (state) => state.Auth.useClientPool,
    NotificationsWssUrl: (state, role) => {
        return state.Auth.eventsWssUrl;
    },
    BuildDirectoryUrl: (state, path) => state.Auth.directoryUrl + path,
    BuildBorrowerUrl: (state) => state.Auth.confirmationUrl + "/borrower",
    BuildLenderUrl: (state) => state.Auth.confirmationUrl + "/lender",
    BuildRoleUrl: (state) => {
        const role = TopBarSelectors.Role(state);
        if (role === ROLE.LENDER) {
            return AuthSelectors.BuildLenderUrl(state);
        }
        return AuthSelectors.BuildBorrowerUrl(state);
    },
    BuildServerSideConfirmationsUrl: (state) => {
        const role = TopBarSelectors.Role(state);
        if (role === ROLE.LENDER) {
            return state.Auth.confirmationUrl + "/data/lender";
        }
        return state.Auth.confirmationUrl + "/data/borrower";
    },
    BuildNoRoleConfirmationsUrl: (state, id) =>
        state.Auth.confirmationUrl + "/confirmation/" + id,
    BuildStoreExtConfirmationsUrl: (state) =>
        state.Auth.confirmationUrl + "/store/borrower",
    BuildStoreConfirmationsFilterValueUrl: (state) => {
        const role = TopBarSelectors.Role(state);
        if (role === ROLE.LENDER) {
            return state.Auth.confirmationUrl + "/data/value/distinct/LENDER";
        }
        return state.Auth.confirmationUrl + "/data/value/distinct/BORROWER";
    },
    IsReady: (state) => state.Auth.isReady,
    AppReady: (state) => state.Auth.appReady,
    BuildMarketDataPortfolioUrl: (state, portfolioId) =>
        state.Auth.marketDataUrl + "/etfs/" + portfolioId,
    BuildMarketDataUrl: (state, stockSymbol) =>
        state.Auth.marketDataUrl + "/stocks/" + stockSymbol.trim(),
    BuildSecuritySearchUrl: (state) =>
        state.Auth.marketDataUrl + "/stocks/search",
    BuildMarketRefDataUrl: (state, stockId, optionalDate) =>
        `${state.Auth.marketDataUrl}/rdata/${stockId}${
            optionalDate ? "?date=" + optionalDate : ""
        }`,
    BuildExchangeRatesUrl: (state) => state.Auth.marketDataUrl + "/currencies",
    BuildExRatesWithCodeUrl: (state, exCode) =>
        state.Auth.marketDataUrl + `/currencies/${exCode}`,
    MarketDataBatchUrl: (state) => state.Auth.marketDataBatchUrl,
    BuildTxBorrowInitUrl: (state) => state.Auth.txUrl + "/borrower/pre-loan",
    BuildTxPortfolioInitUrl: (state) =>
        state.Auth.txUrl + "/borrower/etf-portfolio-loan",
    BuildTxBorrowStartBatchUrl: (state) =>
        state.Auth.txUrl + "/borrower/start-batch",
    BuildTxAcceptOffer: (state) => state.Auth.txUrl + "/borrower/loan-request",
    BuildTxBorrowReject: (state) => state.Auth.txUrl + "/borrower/reject",
    BuildTxBorrowUpgrade: (state) => state.Auth.txUrl + "/borrower/upgrade",
    BuildTxBorrowRelease: (state) => state.Auth.txUrl + "/borrower/release",
    BuildTxBorrowListUrl: (state) => state.Auth.txUrl + "/borrower/tx/today",
    BuildTxLenderListUrl: (state) => state.Auth.txUrl + "/lender/tx/today",
    BuildTxLenderOfferUrl: (state) => state.Auth.txUrl + "/lender/offer/create",
    BuildTxLenderReject: (state) => state.Auth.txUrl + "/lender/reject",
    BuildTxLenderFork: (state) => state.Auth.txUrl + "/lender/fork",
    BuildOfferDraftUrl: (state) => state.Auth.txUrl + "/lender/offer/draft",

    BuildRecallGetUrl: (state) => {
        const role = TopBarSelectors.Role(state);
        if (role === ROLE.LENDER) {
            return state.Auth.recallUrl + "/data/lender";
        }
        return state.Auth.recallUrl + "/data/borrower";
    },
    BuildRecallLenderRequestUrl: (state) =>
        state.Auth.recallUrl + "/lender/recall/create",
    BuildRecallLenderCancelUrl: (state) =>
        state.Auth.recallUrl + "/lender/recall/cancel",
    BuildRecallBorrowerDisputeUrl: (state) =>
        state.Auth.recallUrl + "/borrower/recall/dispute",

    BuildInventoryReplace: (state) => state.Auth.inventoryUrl + "/upload",
    BuildInventoryAdd: (state) => state.Auth.inventoryUrl + "/add",
    BuildInventoryUpdate: (state) => state.Auth.inventoryUrl + "/update",
    BuildInventoryDelete: (state) => state.Auth.inventoryUrl,
    BuildDeleteInventoryEntries: (state) =>
        state.Auth.inventoryUrl + "/entries",
    BuildSpecificInventory: (state, security) =>
        state.Auth.inventoryUrl + "/" + security.market + "/" + security.ticker,
    BuildTodayInventory: (state) => state.Auth.inventoryUrl + "/",
    BuildAvailabilityUrl: (state) => state.Auth.availabilityUrl,
    BuildLenderFetchSettingsUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/lender",
    BuildBorrowerFetchSettingsUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/borrower",
    BuildPutSettingsUrl: (state) => state.Auth.settingsUrl + "/cpty",
    BuildPutLenderBlockedSecuritiesUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/lender/blocked-securities",
    BuildPutLenderListOrderUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/lender/lists/order",
    BuildPutLenderListSettingsUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/lender/lists",
    BuildPutBorrowerFundSettingsUrl: (state) =>
        state.Auth.settingsUrl + "/cpty/borrower/lists",
    BuildUserSettingsUrl: (state) => state.Auth.settingsUrl + "/user",
    BuildPeerCptySettingsUrl: (state) => state.Auth.settingsUrl + "/cpty/peers",
    BuildGetLDSecureHashUrl: (state) => state.Auth.settingsUrl + "/ld-hash",
    BuildEAUpgradeRequestApproveUrl: (state, confirmationId) =>
        state.Auth.txUrl +
        "/lender/ea/" +
        confirmationId +
        "/upgrade-request/approve",
    BuildEAUpgradeRequestRejectUrl: (state, confirmationId) =>
        state.Auth.txUrl +
        "/lender/ea/" +
        confirmationId +
        "/upgrade-request/reject",
    BuildSecurityListPositionsUrl: (state) =>
        state.Auth.positionsUrl + "/data/security-list-positions",
    BuildUserPositionsUrl: (state) =>
        state.Auth.positionsUrl + "/data/user-positions",
    BuildPostTradePositionsUrl: (state) =>
        state.Auth.postTradeUrl + "/positions",
    BuildTradeMonitorSummaryUrl: (state, from, to) => {
        let url = state.Auth.tradeMonitorUrl + "/summary";
        const params = [];
        if (from) params.push(`from=${from}`);
        if (to) params.push(`to=${to}`);
        if (params.length > 0) url += "?" + params.join("&");
        return url;
    },
    BuildTradeMonitorMarketBreakdownUrl: (state, from, to) => {
        let url = state.Auth.tradeMonitorUrl + "/market-breakdown";
        const params = [];
        if (from) params.push(`from=${from}`);
        if (to) params.push(`to=${to}`);
        if (params.length > 0) url += "?" + params.join("&");
        return url;
    },
};
